module.exports = __webpack_public_path__ + "img/zoom-box.8db459d6.svg";